import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import {
  Button,
  Card,
  Col,
  Form,
  Input,
  message,
  Radio,
  Row,
  Space,
} from 'antd';

import { bulkRoleUpdateCreate } from 'app/redux/actions/initiatives';

const RolesForm = ({ rolesList, initiativeID }) => {
  const dispatch = useDispatch();

  const [errorMessage, setErrorMessage] = useState(null);

  const [inputFields, setInputFields] = useState(() => {
    if (rolesList?.length > 0)
      return rolesList.map(obj => {
        const role = obj?.node;
        console.log('role: ', role);

        return {
          pk: role.pk,
          title: role.title,
          probation_hours: role.probationHours,
          probation_hour_rate: role.probationHourRate,
          after_probation_rate: role.afterProbationRate,
          after_probation_rate_type: role.afterProbationRateType,
          days_off: role.daysOff,
        };
      });
    else
      return [
        {
          title: '',
          probation_hours: 0,
          probation_hour_rate: 0,
          after_probation_rate: 0,
          after_probation_rate_type: '',
          days_off: 0,
        },
      ];
  });

  const handleFormChange = (index, event) => {
    let data = [...inputFields];
    data[index][event.target.name] = event.target.value;
    setInputFields(data);
  };

  const addFields = () => {
    const newField = {
      title: '',
      probation_hours: 0,
      probation_hour_rate: 0,
      after_probation_rate: 0,
      days_off: 0,
    };
    setInputFields([...inputFields, newField]);
  };

  const removeFields = index => {
    let data = [...inputFields];
    data.splice(index, 1);
    setInputFields(data);
  };

  const onFinish = async () => {
    const response = await dispatch(
      bulkRoleUpdateCreate(initiativeID, inputFields),
    );

    if (typeof response === 'string' && response.includes('Error'))
      setErrorMessage(response);
    else {
      setErrorMessage(null);

      message.config({
        top: 0, // push to the top
      });

      message.success({
        content: 'Updated Successfully',
        duration: 2, // Displays the success message for 2 seconds
      });

      // Wait for the success message to disappear before reloading
      setTimeout(() => {
        window.location.reload();
      }, 2000); // Matches the duration of the success message
    }
  };

  return (
    <Form onFinish={onFinish}>
      {errorMessage && <p className="text-error">{errorMessage}</p>}

      <Form.List name="rolesForm" initialValue={inputFields}>
        {(fields, { add, remove }) => (
          <>
            {fields.map((field, index) => (
              <Card
                title={'Role #' + (index + 1)}
                className="mb-3"
                key={field.key}
                extra={
                  !('pk' in inputFields[index]) && (
                    <Button
                      onClick={() => {
                        removeFields(index);
                        remove(field.name);
                      }}
                    >
                      Remove
                    </Button>
                  )
                }
              >
                <Row gutter={[8, 8]}>
                  <Col md={8} xs={24}>
                    <Form.Item
                      name={[index, 'title']}
                      label="Title"
                      rules={[
                        {
                          required: true,
                          message: "'title' is required",
                        },
                      ]}
                    >
                      <Input
                        name="title"
                        onChange={event => handleFormChange(index, event)}
                      />
                    </Form.Item>
                  </Col>

                  <Col md={8} xs={24}>
                    <Form.Item
                      name={[index, 'probation_hours']}
                      label="Probation Hours"
                      rules={[
                        {
                          required: true,
                          message: "'probation_hours' is required",
                        },
                      ]}
                      initialValue={0}
                    >
                      <Input
                        name="probation_hours"
                        type="number"
                        min="0"
                        step="1"
                        onChange={event => handleFormChange(index, event)}
                      />
                    </Form.Item>
                  </Col>

                  <Col md={8} xs={24}>
                    <Form.Item
                      name={[index, 'probation_hour_rate']}
                      label="Probation Hour Rate"
                      rules={[
                        {
                          required: true,
                          message: "'probation_hour_rate' is required",
                        },
                      ]}
                      initialValue={0}
                    >
                      <Input
                        name="probation_hour_rate"
                        type="number"
                        min="0"
                        step="0.5"
                        onChange={event => handleFormChange(index, event)}
                      />
                    </Form.Item>
                  </Col>
                </Row>

                <Row gutter={[8, 8]}>
                  <Col md={8} xs={24}>
                    <Form.Item
                      name={[index, 'after_probation_rate_type']}
                      label="After Probation Rate Type"
                      rules={[
                        {
                          required: true,
                          message: "'after_probation_rate_type' is required",
                        },
                      ]}
                    >
                      <Radio.Group
                        name="after_probation_rate_type"
                        onChange={event => handleFormChange(index, event)}
                      >
                        <Space direction="vertical">
                          <Radio key="per_hour" value="Per Hour">
                            Per Hour
                          </Radio>

                          <Radio key="per_day" value="Per Day">
                            Per Day
                          </Radio>

                          <Radio key="per_month" value="Per Month">
                            Per Month
                          </Radio>
                        </Space>
                      </Radio.Group>
                    </Form.Item>
                  </Col>

                  <Col md={8} xs={24}>
                    <Form.Item
                      name={[index, 'after_probation_rate']}
                      label="After Probation Rate"
                      rules={[
                        {
                          required: true,
                          message: "'after_probation_rate' is required",
                        },
                      ]}
                      initialValue={0}
                    >
                      <Input
                        name="after_probation_rate"
                        type="number"
                        min="0"
                        step="0.5"
                        onChange={event => handleFormChange(index, event)}
                      />
                    </Form.Item>
                  </Col>

                  <Col md={8} xs={24}>
                    <Form.Item
                      name={[index, 'days_off']}
                      label="Number of Days Off"
                      rules={[
                        {
                          required: true,
                          message: "'days_off' is required",
                        },
                      ]}
                      initialValue={0}
                    >
                      <Input
                        name="days_off"
                        type="number"
                        min="0"
                        step="1"
                        onChange={event => handleFormChange(index, event)}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Card>
            ))}

            <Row gutter={[8, 8]}>
              <Col>
                <Form.Item>
                  <Button
                    onClick={() => {
                      addFields();
                      add();
                    }}
                  >
                    Add More
                  </Button>
                </Form.Item>
              </Col>

              <Col>
                <Button htmlType="submit">Save Changes</Button>
              </Col>
            </Row>
          </>
        )}
      </Form.List>
    </Form>
  );
};

export default RolesForm;
